import { render, staticRenderFns } from "./ordered-list.vue?vue&type=template&id=68ed6a87&scoped=true&"
import script from "./ordered-list.vue?vue&type=script&lang=ts&"
export * from "./ordered-list.vue?vue&type=script&lang=ts&"
import style0 from "./ordered-list.vue?vue&type=style&index=0&id=68ed6a87&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ed6a87",
  null
  
)

export default component.exports